import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { User } from 'src/app/models/user.model';
import { AccountService } from 'src/app/services/account.service';
import { AccountComponent } from 'src/app/account/account.component';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { NgClass } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styleUrls: ['./account-settings.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class AccountSettingsComponent {

  private formBuilder = inject(FormBuilder);
  private accountService = inject(AccountService);
  private accountComponent = inject(AccountComponent);
  private notificationService = inject(NotificationService);

  user: User;

  public nameForm: FormGroup;
  private firstName: FormControl;
  private lastName: FormControl;
  submittedNameForm = false;
  nameform;
  isWaitingNameReq = false;

  public emailForm: FormGroup;
  private email: FormControl;
  emailform;
  submittedEmailForm = false;
  isWaitingSetMailReq = false;
  sideTab = 'Account_Informations';

  hassubscribeLastValidState = true;
  isWaitingMailReq = false;

  constructor() {
    this.firstName = new FormControl('', [Validators.required]);
    this.lastName = new FormControl('', [Validators.required]);
    this.nameForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
    });
    this.nameform = this.nameForm.controls;

    this.email = new FormControl('', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$')]));
    this.emailForm = this.formBuilder.group({
      email: this.email,
    });
    this.emailform = this.emailForm.controls;

    this.accountService.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe((next: User) => {
        this.user = next;
      });
  }

  onSubmitNameForm() {
    this.submittedNameForm = true;
    if (this.nameForm.invalid) {
      return;
    }
    this.isWaitingNameReq = true;
    this.accountComponent.showToast('Updating name', 2);
    this.accountService.updateAccountOwner(this.nameForm.value.firstName, this.nameForm.value.lastName)
    .subscribe(
      (_response) => {
        this.notificationService.success('Your account name has been updated');
        this.isWaitingNameReq = false;
      },
      (_error) => {
        this.isWaitingNameReq = false;
        this.notificationService.error('Failed to update name');
      }
    );
  }

  onNewsletterToggle(arg: any) {
    this.user.has_subscribed_to_newsletter = arg.target.checked;
    this.isWaitingMailReq = true;
    this.accountComponent.showToast(this.user.has_subscribed_to_newsletter ? 'Subscribing' : 'Unsubscribing', 2);
    this.accountService.subscribeAccountToNewsLetter(this.user.has_subscribed_to_newsletter)
      .subscribe(
        (_response) => {
          this.isWaitingMailReq = false;
          this.notificationService.success(this.user.has_subscribed_to_newsletter ? 'You have subscribed to the newsletter' : 'You have unsubscribed from the newsletter');
          this.hassubscribeLastValidState = this.user.has_subscribed_to_newsletter;
        },
        (_error) => {
          this.isWaitingMailReq = false;
          this.notificationService.error('Failed to update newsletter preference');
          (arg.target as HTMLInputElement).checked = this.hassubscribeLastValidState;
        }
      );
  }

  changeEmail() {
    location.href = environment.apiURL + "/email-change/";
  }

  setEmail() {
    if (this.emailForm.invalid || this.isWaitingSetMailReq) {
      return;
    }
    this.isWaitingSetMailReq = true;
    this.accountComponent.showToast('Adding email address', 2);

    this.accountService.setEmail(this.emailForm.value.email)
      .subscribe(
        (_response) => {
          this.notificationService.success('Your email has been set');
          this.isWaitingSetMailReq = false;
        },
        (_error) => {
          this.notificationService.error('Failed to set your email');
          this.isWaitingSetMailReq = false;
        }
      );
  }

  sendMailActivation() {
    this.isWaitingSetMailReq = true;
    this.accountComponent.showToast('Sending confirmation email', 2);

    this.accountService.sendMailActivation()
      .subscribe(
        (_response) => {
          this.notificationService.success('Confirmation email sent');
          this.isWaitingSetMailReq = false;
        },
        (_error) => {
          this.notificationService.error('Failed to send email');
          this.isWaitingSetMailReq = false;
        }
      );
  }

  clearUnverifiedEmail() {
    if (this.user.has_verified_email || this.isWaitingSetMailReq)
      return;

    this.isWaitingSetMailReq = true;
    this.accountComponent.showToast('Clearing email address', 2);

    this.accountService.clearUnverifiedEmail()
      .subscribe(
        (_response) => {
          this.notificationService.success('Your email has been cleared');
          this.isWaitingSetMailReq = false;
        },
        (_error) => {
          this.notificationService.error('Failed to clear your email');
          this.isWaitingSetMailReq = false;
        }
      );
  }

}
